<template>
    <div class="card-form forgot_password__form mx-auto">
        <div class="forgot_password__header">
            <h2 class="forgot_password__title">{{$t('lang.login.restore_password_title')}}</h2>
        </div>
        <div class="forgot_password__content field">
            <IconField iconPosition="right">
                <InputIcon class="pi pi-at" />
                <InputText
                    :class="[v$.currentEmail.$error ?  'p-invalid' : '']"
                    v-model="currentEmail"
                    type="email"
                    name="email"
                    :placeholder="$t('lang.pages.forgotpassword.email_placeholder')"
                    required
                />
            </IconField>
            <span
                v-if="v$.currentEmail.$error && v$.currentEmail.$errors[0].$message > 0"
                class="registration__text-error"
            >
                {{ v$.currentEmail.$errors[0].$message }}
            </span>
        </div>
        <Button
            type="submit"
            class="forgot_password__btn"
            :class="[disableBtn ? 'registration__btn-disabled' : '']"
            :disabled="disableBtn"
            :label="$t('lang.pages.forgotpassword.button_label')"
            @click="sendEmail"
        />
        <AdaptersMessage v-if="error" class="forgot_password__message" :message="error" />
        <AdaptersMessage
            v-if="info"
            class="forgot_password__message"
            :message="info"
            severity="success"
            icon="pi pi-info-circle"
        />
    </div>
</template>

<script>
import TemplatesPage from "../../templates/Page.vue";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import { email, helpers, required } from "@vuelidate/validators";
import { useI18n } from "vue-i18n";
import { useVuelidate } from "@vuelidate/core";
import AdaptersMessage from "../../component/adapters/Message.vue";
import UserApi from "../../api/UserApi";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";

export default {
    components: {
        AdaptersMessage,
        TemplatesPage,
        InputText,
        Button,
        IconField,
        InputIcon,
    },

    data() {
        return {
            currentEmail: '',
            disableBtn: true,
            error: '',
            info: '',
            v$: null, // для валидации
        };
    },

    created() {
        // Правила валидации
        const rules = {
            currentEmail: {
                required: helpers.withMessage('', required),
                email: helpers.withMessage(this.$t('lang.registration.incorrect_email'), email),
            },
        };

        // Инициализация Vuelidate
        this.v$ = useVuelidate(rules, this);
    },
    methods: {
        sendEmail() {
            this.error = '';
            this.v$.$validate();
            this.disableBtn = this.v$.$errors.length > 0;

            if (!this.disableBtn) {
                this.disableBtn = true;
                UserApi
                    .forgotPassword({
                        email: this.currentEmail,
                    })
                    .then(() => {
                        this.info = this.$t('lang.pages.forgotpassword.info_success');
                    })
                    .catch((error) => {
                        this.disableBtn = false;
                        this.error = error.message;
                    });
            }
        },
    },
    watch: {
        currentEmail() {
            this.v$.currentEmail.$validate();
            this.disableBtn = this.v$.$errors.length > 0;
        }
    }
};
</script>

<style scoped>
:deep(.p-message.p-message-success .p-message-icon) {
    display: unset;
    color: #9CD651;
}

.p-message.p-message-success {
    background: #ecf8dd;
    border: solid #9CD651;
    border-width: 0 0 0 6px;
    color: #475569;
}

.p-button {
    font-size: 0.875rem!important;
}

</style>
